import { FormattedMessage as Message } from 'react-intl';

import type { TpFormattedMessage } from '../../types';

export const FormattedMessage = (props: TpFormattedMessage) => {
  const { defaultMessage, id, values, ...otherProps } = props;

  return (
    <span data-trans={id}>
      <Message
        data-trans={id}
        id={id}
        values={{
          br: <br />,
          ...values,
        }}
        defaultMessage={defaultMessage}
        {...otherProps}
      />
    </span>
  );
};
